import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPinFlag: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPinFlag"><Path d="M12 17.5V10.5M12 10.5V2.5L18.5 6.5L12 10.5ZM13.5 13.5496C18.034 13.8524 21.5 15.5058 21.5 17.5C21.5 19.7091 17.2467 21.5 12 21.5C6.75329 21.5 2.5 19.7091 2.5 17.5C2.5 15.5058 5.96602 13.8524 10.5 13.5496" stroke="currentColor"/></CentralIconBase>;
});

export default IconPinFlag;
